const REACTIVATE_TODAY = '/reactivate-today';
const REACTIVATE_THANKS = '/reactivate-thanks';
const ACTIVATE_BOX_SUBSCRIPTION = '/activate-box-subscription';
const EMAIL_PREFERENCES = '/manage-email-preferences';
const SUBSCRIBE_TODAY_THANKS = '/subscribe-today-thanks';
const ORDER_TRACKING = '/orders/track-shipment';
const MY_ACCOUNT = '/my-account';
const LOCK_IN_RATE_PATH = '/lock-in-rate';
const CONTACT_US_PATH = '/contact-us';

export {
  LOCK_IN_RATE_PATH,
  CONTACT_US_PATH,
  REACTIVATE_TODAY,
  REACTIVATE_THANKS,
  ACTIVATE_BOX_SUBSCRIPTION,
  EMAIL_PREFERENCES,
  SUBSCRIBE_TODAY_THANKS,
  MY_ACCOUNT,
  ORDER_TRACKING,
};
